<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">จัดการคะแนนหลักสูตร</h2>
    </div>
    <div v-if="courseList.length > 0">
      <div class="pd-b-3 flex-display js-between change-display">
        <div class="text-left flex-display ai-center change-display">
          <p class="mg-less">เลือกหลักสูตร</p>
          <el-dropdown class="mg-l-4" trigger="click">
            <span class="el-dropdown-link course-box">
              <span class="message-over clamp1">{{
                getCourseLabel(course)
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="course-box-menu">
              <el-dropdown-item v-for="item in courseList" :key="item._id"
                ><div
                  @click="course = item._id"
                  class="dropdown-text-over"
                  :title="item.name"
                >
                  {{ item.name }}
                </div></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            @click="selectCourse"
            type="primary"
            class="light mg-l-4 btn-show"
            round
            >แสดงผล</el-button
          >
        </div>
        <div class="flex-display js-end search-download">
          <el-form @submit.prevent.native @keyup.enter.native="search">
            <el-input
              placeholder="ค้นหาชื่อวิชา"
              prefix-icon="el-icon-search"
              class="search-input"
              @blur="showInputSearch = false,!searchText && showSearch?search():null"
              @keyup.enter.native="search"
              @clear="searchText = '',search()"
              :class="{ show: showInputSearch }"
              ref="search"
              clearable
              v-model="searchText"
            ></el-input>

            <el-button
              v-if="!showInputSearch"
              @click="openSearchInput"
              icon="el-icon-search"
              round
              class="pd-x-2 primary border-color-primary"
              >ค้นหา</el-button
            >
          </el-form>
        </div>
      </div>
      <div v-if="showSearch" class="text-left pd-b-3">
        <p class="mg-y-less">
          <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
        </p>
      </div>
      <div v-loading="loading" class="pd-b-3">
        <ActivityTotalScoreList
            :totalScoreList="totalScoreList"
            :searchText="searchText"
            :courseId="courseId"
          />
      </div>
    </div>
    <div v-else class="text-center">
      <p class="color-gray pd-y-1">*** ไม่มีข้อมูลหลักสูตร ***</p>
    </div>
  </DashboardTemplate>
</template>
<style scop="scoped">
@media (max-width: 1099.98px) {
  .custom-activity .change-display {
    display: flex;
  }
}
@media (max-width: 991.98px) {
  .custom-activity .change-display {
    display: block;
  }
}
</style>
<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivityTotalScoreList from "@/components/activity/ActivityTotalScoreList";
import ActivityNamelistScore from "@/components/activity/ActivityNamelistScore";
import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";

export default {
  components: {
    DashboardTemplate,
    ActivityTotalScoreList,
    ActivityNamelistScore,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      let courses = []
      if (this.user.role == 50) {
        this.$store.state.courseList.map((item)=>{
          let filter = item.subject.filter(filter => filter.instructor == this.user.userId)
          if (filter.length > 0) {
            courses.push(item)
          }
        })
      }else{
        courses = this.$store.state.courseList
      }

      return courses.filter(
        (filter) => filter.subject.length > 0
      );
    },
    totalScoreList() {
      return this.totalScoreListConst.filter(
        (filter) =>
          filter.name
            .toLowerCase()
            .indexOf(this.query.toLowerCase()) > -1
      );
    },
  },
  data() {
    return {
      activeName: "1",
      course: "",
      searchText: "",
      showInputSearch: false,
      totalScoreListConst: [],
      showSearch: false,
      loading:true,
      courseId:'',
      source:'',
      query:''
    };
  },
  mounted() {
    this.fetchCourseList();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      this.course = this.courseList.length > 0 ? this.courseList[0]._id : "";
      this.courseId = this.course
      this.fetchManagePoint();
    },
    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    fetchManagePoint() {
      let obj = {
        courseId: this.courseId,
      };

      if (this.source) {
        this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token
     
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`manage/point`, obj,{cancelToken})
        .then((res) => {
          if (res.data.success) {
            this.totalScoreListConst = res.data.obj
       
          } else {
            this.totalScoreListConst = [];
          }
        })
        .catch((e) => {
          console.log("fetchManagePoint error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectCourse() {
      this.loading = true;
      this.courseId = this.course
      this.fetchManagePoint();
    },
    search() {
      this.loading = true;
      this.page = 1
      if (this.searchText != "") {
        this.showSearch = true;
        this.query = this.searchText
      } else {
        this.showSearch = false;
        this.query = ''
      }

      if (this.totalScoreListConst.length > 0) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }

    },
  },
};
</script>